import type { ThemeConfig } from 'antd';
import { COLOR_OPTIONS, FONT_FAMILY, TYPOGRAPHY_LEVEL } from 'config/style';

export { default as localeDE } from 'antd/lib/locale/de_DE';
export { default as localeEL } from 'antd/lib/locale/el_GR';
export { default as localeEN } from 'antd/lib/locale/en_US';
export { default as localeES } from 'antd/lib/locale/es_ES';
export { default as localeFR } from 'antd/lib/locale/fr_FR';
export { default as localeHU } from 'antd/lib/locale/hu_HU';
export { default as localeIT } from 'antd/lib/locale/it_IT';
export { default as localePL } from 'antd/lib/locale/pl_PL';
export { default as localeBR } from 'antd/lib/locale/pt_BR';
export { default as localePT } from 'antd/lib/locale/pt_PT';
export { default as localeRU } from 'antd/lib/locale/ru_RU';

export enum LOCALE_CODES {
  pt_br = 'pt-br',
  pt_pt = 'pt-pt',
  de_de = 'de-de',
  el = 'el',
  fr_fr = 'fr-fr',
  fr = 'fr',
  pl_pl = 'pl-pl',
  es = 'es',
  es_ar = 'es-ar',
  es_AR = 'es-AR',
  hu_hu = 'hu-hu',
  it = 'it',
  ru = 'ru',
  en = 'en'
}

export const THEME: ThemeConfig = {
  token: {
    fontFamily: FONT_FAMILY,
    colorPrimary: COLOR_OPTIONS.GREEN_50,
    colorInfo: COLOR_OPTIONS.BLUE_50,
    colorSuccess: COLOR_OPTIONS.GREEN_PRIMARY,
    colorWarning: COLOR_OPTIONS.YELLOW_40,
    colorError: COLOR_OPTIONS.RED_50,
    colorLink: COLOR_OPTIONS.BLUE_50,
    colorPrimaryHover: COLOR_OPTIONS.GREEN_PRIMARY,
    colorPrimaryActive: COLOR_OPTIONS.GREEN_70,
    colorPrimaryBgHover: COLOR_OPTIONS.GREEN_10,
    colorPrimaryBorder: COLOR_OPTIONS.GREEN_40,
    colorPrimaryTextActive: COLOR_OPTIONS.GREEN_70,
    colorTextBase: COLOR_OPTIONS.NEUTRAL_100,
    colorBgBase: COLOR_OPTIONS.NEUTRAL_00,
    colorTextSecondary: COLOR_OPTIONS.NEUTRAL_60,
    colorBorder: COLOR_OPTIONS.NEUTRAL_30,
    colorSuccessHover: COLOR_OPTIONS.GREEN_60,
    colorSuccessBorder: COLOR_OPTIONS.GREEN_40,
    colorSuccessBg: COLOR_OPTIONS.GREEN_10,
    colorWarningHover: COLOR_OPTIONS.YELLOW_50,
    colorWarningBorder: COLOR_OPTIONS.YELLOW_30,
    colorWarningBg: COLOR_OPTIONS.YELLOW_10,
    colorErrorHover: COLOR_OPTIONS.RED_60,
    colorErrorBorder: COLOR_OPTIONS.RED_30,
    colorErrorBg: COLOR_OPTIONS.RED_10,
    colorInfoHover: COLOR_OPTIONS.BLUE_60,
    colorInfoBorder: COLOR_OPTIONS.BLUE_30,
    colorInfoBg: COLOR_OPTIONS.BLUE_10
  },
  components: {
    Button: {
      primaryShadow: '0 0px 0 rgba(5, 145, 255, 0.1)',
      colorPrimary: COLOR_OPTIONS.GREEN_60,
      colorPrimaryHover: COLOR_OPTIONS.GREEN_50,
      colorPrimaryActive: COLOR_OPTIONS.GREEN_70,
      textHoverBg: COLOR_OPTIONS.NEUTRAL_10,
      colorBgTextActive: COLOR_OPTIONS.NEUTRAL_20
    },
    Typography: {
      fontFamily: FONT_FAMILY,
      fontSizeHeading1: TYPOGRAPHY_LEVEL.H1,
      fontSizeHeading2: TYPOGRAPHY_LEVEL.H2,
      fontSizeHeading3: TYPOGRAPHY_LEVEL.H3,
      fontSizeHeading4: TYPOGRAPHY_LEVEL.H4,
      fontSizeHeading5: TYPOGRAPHY_LEVEL.H5,
      titleMarginBottom: '0',
      titleMarginTop: '0'
    },
    Tabs: {
      itemSelectedColor: COLOR_OPTIONS.BLUE_60,
      itemHoverColor: COLOR_OPTIONS.BLUE_60,
      itemActiveColor: COLOR_OPTIONS.BLUE_60,
      inkBarColor: COLOR_OPTIONS.BLUE_60
    },
    DatePicker: {
      fontFamily: FONT_FAMILY
    },
    Checkbox: {
      colorBorder: COLOR_OPTIONS.NEUTRAL_30,
      colorBgContainer: COLOR_OPTIONS.NEUTRAL_00,
      colorPrimary: COLOR_OPTIONS.BLUE_60,
      colorPrimaryBorder: COLOR_OPTIONS.BLUE_60,
      colorPrimaryHover: COLOR_OPTIONS.BLUE_50,
      colorBgContainerDisabled: COLOR_OPTIONS.NEUTRAL_10,
      colorTextDisabled: COLOR_OPTIONS.NEUTRAL_40
    },
    Radio: {
      colorBorder: COLOR_OPTIONS.NEUTRAL_30,
      colorBgContainer: COLOR_OPTIONS.NEUTRAL_00,
      colorPrimary: COLOR_OPTIONS.BLUE_60,
      colorPrimaryBorder: COLOR_OPTIONS.BLUE_60,
      colorPrimaryHover: COLOR_OPTIONS.BLUE_50,
      colorBgContainerDisabled: COLOR_OPTIONS.NEUTRAL_10,
      colorTextDisabled: COLOR_OPTIONS.NEUTRAL_40
    },
    Select: {
      borderRadius: 4,
      colorBorder: COLOR_OPTIONS.NEUTRAL_30,
      colorBgContainer: COLOR_OPTIONS.NEUTRAL_00,
      colorText: COLOR_OPTIONS.NEUTRAL_100,
      colorTextPlaceholder: COLOR_OPTIONS.NEUTRAL_60,
      colorPrimaryHover: COLOR_OPTIONS.BLUE_50,
      colorPrimary: COLOR_OPTIONS.BLUE_50,
      colorBgContainerDisabled: COLOR_OPTIONS.NEUTRAL_20,
      colorTextDisabled: COLOR_OPTIONS.NEUTRAL_50,
      controlOutline: `${COLOR_OPTIONS.BLUE_50}40`,
      optionSelectedBg: COLOR_OPTIONS.BLUE_10,
      optionSelectedColor: COLOR_OPTIONS.NEUTRAL_100,
      optionActiveBg: COLOR_OPTIONS.NEUTRAL_10,
      colorTextQuaternary: COLOR_OPTIONS.NEUTRAL_60
    }
  }
};
